import React from "react";
import FlaskEmpty from "mdi-material-ui/FlaskEmpty";

export default function DataScience(props) {
  return <FlaskEmpty {...props} />;
}
